import { axios } from "@v2/shared/api";
const CART_ENDPOINT = "cart-items";
const PARTICIPANT_ENDPOINT = "participants";

export default {
  get(eventId) {
    return axios.get(`${PARTICIPANT_ENDPOINT}/${eventId}/cart`);
  },

  add(eventId, serviceId, data) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CART_ENDPOINT}/${serviceId}`,
      data
    );
  },

  update(eventId, cartItemId, data) {
    return axios.put(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CART_ENDPOINT}/${cartItemId}`,
      data
    );
  },

  delete(eventId, cartItemId) {
    return axios.delete(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${CART_ENDPOINT}/${cartItemId}`
    );
  }
};
